// assets
import { IconDashboard,IconChartBar, IconHistory, IconUsersGroup,IconArticle, IconReportAnalytics, IconInfoSquare, IconFolderOpen} from '@tabler/icons-react';

// constant
const icons = { IconChartBar,IconHistory, IconDashboard, IconUsersGroup ,IconArticle, IconReportAnalytics, IconInfoSquare,IconFolderOpen};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const qsDashboardMenu = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/qs/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'projects',
            title: 'All Projects',
            type: 'item',
            url: '/qs/projects',
            icon: icons.IconFolderOpen,
            breadcrumbs: false,
            permissions: ['projects.read']
        },
        {
            id: 'certificate',
            title: 'Certificates',
            type: 'item',
            url: '/qs/certificates',
            icon: icons.IconArticle,
            breadcrumbs: false,
            permissions: ['certificates.read']
        },
        {
            id: 'claims',
            title: 'Claims',
            type: 'item',
            url: '/qs/claims',
            icon: icons.IconInfoSquare,
            breadcrumbs: false,
            permissions: ['claims.read']
        },
        {
            id: 'reports',
            title: 'Reports',
            type: 'item',
            url: '/qs/reports',
            icon: icons.IconChartBar,
            breadcrumbs: false,
            permissions: ['reports.read']
        },
        {
            id: 'performance',
            title: 'Officers',
            type: 'item',
            url: '/qs/team',
            target: false,
            icon: icons.IconUsersGroup,
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['dashboard.read']
        },
        {
            id: 'audit',
            title: 'Audit Logs',
            type: 'item',
            icon: icons.IconHistory,
            url: '/qs/audit-logs',
            target: false,  
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['audit_logs.read']
        }
    ]
};

export default qsDashboardMenu;
